import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useTranslation } from '@/i18n';

/**
 * Shown to non-admin users while the system is unconfigured, in place of the
 * first-run setup page they have no rights to use.
 */
export const UnconfiguredNotice: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div
      role="status"
      data-testid="unconfigured-notice"
      className="flex items-start gap-2 px-4 py-3 bg-amber-50 dark:bg-amber-900/20 border-b border-amber-200 dark:border-amber-800 text-amber-900 dark:text-amber-100"
    >
      <AlertTriangle className="w-4 h-4 mt-0.5 flex-shrink-0" aria-hidden="true" />
      <div>
        <p className="font-medium">{t.configuration.notConfiguredTitle}</p>
        <p className="text-amber-800 dark:text-amber-200">
          {t.configuration.notConfiguredBody} {t.configuration.notConfiguredContactAdmin}
        </p>
      </div>
    </div>
  );
};
